import { render, staticRenderFns } from "./d2-container-ghost-bs.vue?vue&type=template&id=11671b61"
import script from "./d2-container-ghost-bs.vue?vue&type=script&lang=js"
export * from "./d2-container-ghost-bs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports